import { SITE_LLD_DOWNLOADED, SITE_LLD_FAILED, SITE_LLD_PENDING, SITE_LLD_SELECTED } from './types';

const INITIAL_STATE = {
  pending: false,
  error: null,
  content: null,
  selected: ''
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case SITE_LLD_PENDING:
      return {
        ...state,
        pending: true
      }
    case SITE_LLD_FAILED:
      return {
        ...state,
        pending: false,
        error: action.payload
      }
    case SITE_LLD_DOWNLOADED:
      return {
        ...state,
        pending: false,
        content: action.payload
      }
    case SITE_LLD_SELECTED:
      return {
        ...state,
        selected: action.payload
      }
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/sitesLld/reducers.js